import { NgModule } from "@angular/core";
import { RaskCommonModule } from "../../../common/rask-common.module";
import { MatinfoSearchComponent } from "./matinfo/matinfo-search/matinfo-search.component";
import { MatinfoComponent } from "./matinfo/matinfo.component";
import { RedovisningshanvisningExtraDialogComponent } from "./redovisningshanvisning/redovisningshanvisning-extra-dialog/redovisningshanvisning-extra-dialog.component";
import { RedovisningshanvisningSearchComponent } from "./redovisningshanvisning/redovisningshanvisning-search/redovisningshanvisning-search.component";
import { RedovisningshanvisningComponent } from "./redovisningshanvisning/redovisningshanvisning.component";
import { RegelverkViol3Component } from "./regelverk-viol3.component";
import { RegelverkViol3Service } from "./regelverkViol3.service";

@NgModule({
    imports: [
        RaskCommonModule,
        RegelverkViol3Component,
        RedovisningshanvisningComponent,
        RedovisningshanvisningSearchComponent,
        RedovisningshanvisningExtraDialogComponent,
        MatinfoComponent,
        MatinfoSearchComponent
    ],
    providers: [RegelverkViol3Service]
})
export class RegelverkViol3Module { }
